<template>
  <form
    class="form-inline search-full col"
    action="#"
    method="get"
    @submit.prevent=""
    :class="searchOpen?'open':'' "
  >
    <div class="form-group w-100">
      <div class="Typeahead Typeahead--twitterUsers">
        <div class="u-posRelative">
          <input
            class="demo-input Typeahead-input form-control-plaintext w-100"
            type="text"
            v-model="terms" 
            placeholder="escribe tu búsqueda..."
            name="q"
            title=""
            autofocus
            
          />
          <div class="spinner-border Typeahead-spinner" role="status">
            <span class="sr-only">Consultando...</span>
          </div>
          <vue-feather
            class="close-search"
            type="x"
            @click="search_close()"
          ></vue-feather>
        </div>
        <div
          :class="searchResult ? 'Typeahead-menu is-open' : 'Typeahead-menu'"
          v-if="menuItems.length"
        >
          <div
            class="ProfileCard u-cf"
            v-for="(menuItem, index) in menuItems.slice(0, 8)"
            :key="index"
          >
            <div class="ProfileCard-avatar header-search">
              <!-- <vue-feather :type="menuItem.icon"></vue-feather> -->
              <svg class="stroke-icon">
                <use :xlink:href="require('@/assets/svg/icon-sprite.svg')+`#${menuItem.icon}`"></use>
              </svg>
            </div>
            <div class="ProfileCard-details">
              <div class="ProfileCard-realName">
                <span @click="removeFix()"
                  ><router-link
                    :to="{ path: menuItem.path }"
                    class="realname"
                    >{{ menuItem.title }}</router-link
                  ></span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          :class="
          searchResultEmpty ? 'Typeahead-menu is-open' : 'Typeahead-menu'
          "
        >
          <div class="tt-dataset tt-dataset-0">
            <div class="EmptyMessage">
              Tu búsqueda localizó 0 resultados.
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  var body = document.getElementsByTagName('body')[0];
  import { ref, watch } from 'vue';
  import { useMenuStore } from '@/stores/menu';
  import { storeToRefs } from 'pinia';

  export default {
    name: 'SearchBar',
    setup() {
      const menuStore = useMenuStore();
      const { searchData, searchOpen } = storeToRefs(menuStore);
      const terms = ref('');
      const searchResult = ref(false);
      const searchResultEmpty = ref(false);

      watch(terms, (value) => {
        value ? addFix() : removeFix();
        menuStore.searchTerm(value);
        if (!searchData.value || searchData.value.length === 0) searchResultEmpty.value = true;
        else searchResultEmpty.value = false;
      }, { deep: true });

      function search_open() {
        menuStore.searchOpen = true;
      }

      function search_close() {
        menuStore.searchOpen = false;
        body.classList.remove('offcanvas');
      }

      function searchterm() {
        menuStore.searchTerm(terms.value);
      }

      function addFix() {
        body.classList.add('offcanvas');
        searchResult.value = true;
      }

      function removeFix() {
        body.classList.remove('offcanvas');
        searchResult.value = false;
        terms.value = '';
      }

      return {
        terms,
        searchResult,
        searchResultEmpty,
        menuItems: searchData,
        searchOpen,
        search_open,
        search_close,
        searchterm,
        addFix,
        removeFix,
      };
    }
  };
</script>
